import script from "./SidenavCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&setup=true&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=86d4ceb8&lang=css"

const __exports__ = script;

export default __exports__